import { COUNT_TABLE_RECORDS } from 'constants/constants';
import CPagination from 'rc-pagination';
import s from './Pagination.module.scss';

interface IPaginationProps {
  changePage: (page: number) => void;
  currentPage: number;
  /** null without data (rc-pagination gets it as it is). */
  total: number | null;
}

/**
 * The `total` prop as a spread: rc-pagination types it as a number, but the callers pass null without data, which
 * rc-pagination takes apart from undefined (no default). TypeScript checks no named prop against a spread with an
 * index signature only.
 */
const totalProp = (total: number | null): Record<string, number | null> => ({ total });

const Pagination = ({ changePage, currentPage, total }: IPaginationProps) => {
  return (
    <CPagination
      prevIcon={<div className={s.arrowBack} />}
      nextIcon={<div className={s.arrowForward} />}
      pageSize={COUNT_TABLE_RECORDS}
      onChange={changePage}
      current={currentPage}
      {...totalProp(total)}
    />
  );
};

export default Pagination;
